<template>
	<section>
		<template v-if="Object.keys(error).length > 0 && error.statusCode == 404">
			<NuxtLayout>
				<section>
					<div class="flex flex-col items-center">
						<div class="flex flex-col sm:flex-row mb-16 sm:mb-0 items-center">
							<BaseCloudImage
								class="max-w-[260px] sm:max-w-full"
								public-id="content/DreamJobs/Graphics/pic_404"
								postfix=".svg"
								alt="404"
							/>
							<div class="flex flex-col sm:ml-16 text-center sm:text-left">
								<h1 class="text-5xl mb-4 sm:mb-0 sm:text-7xl font-semibold">404</h1>
								<span class="text-2xl sm:text-3xl">{{ $t("404.title") }}</span>
							</div>
						</div>
						<span class="text-3xl mt-11 mb-8 hidden md:block">{{ $t("404.subtitle") }}</span>
						<SearchbarMain class="mb-32 hidden md:flex" />
					</div>
				</section>
			</NuxtLayout>
		</template>
		<template v-else>
			<NuxtLayout>
				<section>
					<div class="flex flex-col items-center">
						<div class="flex flex-col sm:flex-row mb-16 sm:mb-0 items-center">
							<BaseCloudImage
								class="max-w-[260px] sm:max-w-full"
								public-id="content/DreamJobs/Graphics/pic_404"
								postfix=".svg"
								alt="404"
							/>
							<div class="flex flex-col sm:ml-16 text-center sm:text-left">
								<h1 class="text-5xl mb-4 sm:mb-0 sm:text-7xl font-semibold">{{ error.statusCode }}</h1>
								<span class="text-2xl sm:text-3xl">{{ $t("500.title") }}</span>
							</div>
						</div>
						<span class="text-3xl mt-11 mb-8 hidden md:block">{{ $t("500.subtitle") }}</span>
						<SearchbarMain class="mb-32 hidden md:flex" />
					</div>
				</section>
			</NuxtLayout>
		</template>
	</section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		error: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
});
</script>
